import React from 'react';
import { motion } from 'framer-motion';
import { TrustBadges } from './TrustBadges';
interface CTAButtonProps {
  text: string;
  microcopy?: string;
  href?: string;
  className?: string;
  icon?: ReactNode;
}
export function CTAButton({
  text,
  microcopy,
  href = '#pricing',
  className = '',
  icon
}: CTAButtonProps) {
  return <div className={`flex flex-col items-center justify-center w-full ${className}`} data-id="element-27">
      <motion.a href={href} animate={{
      boxShadow: ['0px 0px 0px rgba(196,30,58,0)', '0px 0px 20px rgba(196,30,58,0.6)', '0px 0px 0px rgba(196,30,58,0)']
    }} transition={{
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className="flex items-center justify-center gap-3 w-full max-w-md text-center bg-gradient-to-r from-[#C41E3A] to-[#8B2252] text-white font-body font-bold text-lg md:text-xl py-4 px-8 rounded-full transition-all duration-300" data-id="element-28">
        {icon && <span className="flex-shrink-0" data-id="element-29">{icon}</span>}
        <span data-id="element-30">{text}</span>
      </motion.a>
      {microcopy && <p className="mt-3 text-sm text-mutedBrown font-body text-center max-w-md opacity-90" data-id="element-31">
          {microcopy}
        </p>}
      <TrustBadges data-id="element-32" />
    </div>;
}